import { FC, memo } from 'react';
import { DatePicker, Skeleton, Table } from 'antd';
import dayjs from 'dayjs';
import cn from 'classnames';
import { useMedVoxEvents } from '../../../hooks/components/useMedVoxEvents';
import { TableResults } from '../../shared/TableResults';
import { COLUMNS } from './constants';
import styles from './styles.module.css';

interface Props {
  showMedVox: boolean;
}

const MedVoxEvents: FC<Props> = memo(({ showMedVox }: Props) => {
  const props = useMedVoxEvents();

  return (
    <div className={styles.MedVoxEvents}>
      {props.status.responseLoading ? (
        <Skeleton active />
      ) : (
        <div
          className={cn({
            [styles.blockContainer]: showMedVox,
            [styles.blockContainerCenter]: showMedVox,
            [styles.invisible]: Boolean(showMedVox),
          })}
        >
          <div className={styles.dateContainer}>
            <label className={styles.label}>Дата событий:</label>
            <DatePicker
              className={styles.datePicker}
              format={'DD.MM.YYYY'}
              defaultValue={dayjs()}
              onChange={(value) =>
                value &&
                props.setEventRequest({
                  ...props.eventRequest,
                  selectedDate: value.format('DD.MM.YYYY'),
                  Filter: value.format('YYYY-MM-DD'),
                })
              }
            />
          </div>
          <TableResults
            isEmpty={
              props.currentEvents.length === 0 &&
              props.totalCount === 0 &&
              !props.status.responseError
            }
            loading={props.status.responseLoading}
          >
            <Table
              columns={COLUMNS}
              className={styles.table}
              pagination={{
                pageSize: props.pageSize,
                defaultCurrent: 1,
                responsive: true,
                total: props.totalCount,
                onChange: props.handleChange,
                current: props.eventRequest.PageIndex + 1,
              }}
              showSorterTooltip={false}
              dataSource={props.currentEvents}
              rowKey={(record) => record.id}
            />
          </TableResults>
        </div>
      )}
    </div>
  );
});
MedVoxEvents.displayName = 'MedVoxEvents';
export default MedVoxEvents;
